module.exports = __webpack_public_path__ + "img/third-block-title.377a8104.png";